import React from 'react'

import EnterAccountPasswordWrapper from '../../../modules/enter-account-password-modal/enter-account-password-wrapper'
import SubscriptionContent from './subscription-content'

function ManageSubscription() {
  return (
    <EnterAccountPasswordWrapper>
      <SubscriptionContent />
    </EnterAccountPasswordWrapper>
  )
}

export default ManageSubscription
